var _circle, _circle2, _circle3, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImg263(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 34.5,
    r: 12.5,
    fill: "#86DEF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.3651,
    cy: 9.68526,
    r: 1.5,
    transform: "rotate(75 40.3651 9.68526)",
    fill: "#263238"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5214,
    cy: 17.0844,
    r: 1.5,
    transform: "rotate(75 47.5214 17.0844)",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_522_6060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1939 11.2111C48.0034 10.4998 48.4255 9.76868 49.1367 9.57809C49.3075 9.53233 49.4531 9.42059 49.5416 9.26747C49.63 9.11435 49.6539 8.93238 49.6082 8.76159C49.5624 8.59081 49.4507 8.44519 49.2975 8.35679C49.1444 8.26838 48.9624 8.24443 48.7917 8.29019C48.0875 8.49234 47.3544 8.07771 47.1647 7.37004L47.1587 7.34738C47.1129 7.17659 47.0012 7.03098 46.848 6.94258C46.6949 6.85417 46.513 6.83021 46.3422 6.87597C46.1714 6.92174 46.0258 7.03347 45.9374 7.18659C45.849 7.33971 45.825 7.52168 45.8708 7.69247C46.0752 8.40552 45.6477 9.146 44.928 9.32546C44.7572 9.37123 44.6116 9.48296 44.5232 9.63608C44.4347 9.7892 44.4108 9.97117 44.4566 10.142C44.5023 10.3127 44.614 10.4584 44.7672 10.5468C44.9203 10.6352 45.1023 10.6591 45.273 10.6134L45.2957 10.6073C46.0034 10.4177 46.729 10.8452 46.906 11.5562C46.9518 11.727 47.0635 11.8726 47.2167 11.961C47.3698 12.0494 47.5517 12.0733 47.7225 12.0276C47.8933 11.9818 48.0389 11.8701 48.1273 11.717C48.2157 11.5638 48.2397 11.3819 48.1939 11.2111Z",
    fill: "#263238"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_522_6060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5105 39.4998H24.4075C19.03 39.4998 16.342 39.4998 14.671 37.7973C13 36.0948 13 33.3543 13 27.8748C13 22.3953 13 19.6548 14.671 17.9523C16.342 16.2498 19.03 16.2498 24.4075 16.2498H30.112C35.4895 16.2498 38.179 16.2498 39.85 17.9523C41.1355 19.2618 41.431 21.1863 41.5 24.4998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0255 38.0345L43 41M34 16.25L33.85 15.785C33.1075 13.475 32.737 12.32 31.8535 11.66C30.9685 11 29.7955 11 27.445 11H27.0505C24.703 11 23.5285 11 22.645 11.66C21.76 12.32 21.3895 13.475 20.647 15.785L20.5 16.25M41.5795 34.289C41.5913 33.5868 41.4632 32.8894 41.2027 32.2372C40.9422 31.5851 40.5544 30.9913 40.0621 30.4906C39.5697 29.9899 38.9826 29.5922 38.3349 29.3207C37.6872 29.0492 36.992 28.9094 36.2898 28.9094C35.5875 28.9094 34.8923 29.0492 34.2446 29.3207C33.5969 29.5922 33.0098 29.9899 32.5174 30.4906C32.0251 30.9913 31.6373 31.5851 31.3768 32.2372C31.1163 32.8894 30.9882 33.5868 31 34.289C31.0234 35.6765 31.591 36.9993 32.5804 37.9722C33.5699 38.9452 34.9021 39.4904 36.2898 39.4904C37.6775 39.4904 39.0096 38.9452 39.9991 37.9722C40.9885 36.9993 41.5561 35.6765 41.5795 34.289Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_6060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(49.8594 4.55273) rotate(75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_522_6060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(2 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImg263);
export default __webpack_public_path__ + "static/media/icon-img-26-3.5a723c518fafd25feff5d4d84c45bb36.svg";
export { ForwardRef as ReactComponent };